module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767317_07_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767317_08_int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767317_09_pt1#pt1"
    }
  }, [_c('strong', [_vm._v("PART ONE:")]), _vm._v(" The Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767317_10_ch1#ch1"
    }
  }, [_vm._v("Chapter 1: The Llano")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767317_11_ch2#ch2"
    }
  }, [_vm._v("Chapter 2: The City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_12_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_13_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_14_pt2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART TWO:")]), _vm._v(" The Men, First Verse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_15_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Joe, Jimmie, and Butch, Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_16_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: "), _c('em', [_vm._v("Compañeros")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_17_pt3#pt3",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART THREE:")]), _vm._v(" The Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_18_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_19_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: More a Legend")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_20_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_21_pt4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART FOUR:")]), _vm._v(" The Men, Second Verse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_22_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Joe, Jimmie, and Butch, Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_23_pt5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART FIVE:")]), _vm._v(" The Return")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_24_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: More a Band")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_25_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Alchemy: "), _c('em', [_vm._v("Now Again")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_26_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Cruising Speed: "), _c('em', [_vm._v("Wheels of Fortune")]), _vm._v(" and "), _c('em', [_vm._v("Live ’72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_27_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Dust to Dust: "), _c('em', [_vm._v("Hills and Valleys")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_28_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Closing the Circle: "), _c('em', [_vm._v("The Odessa Tapes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_29_epi#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Carnegie Hall: Practice, Practice, Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767317_30_dis#dis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16bc333a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292767317_06_toc.vue
// module id = 75
// module chunks = 0